import React, { useEffect, useState } from "react";
import Switch from '../common/Switch';
import { Form, Modal, Row, Col, Spinner, Image } from "react-bootstrap";
import Swal from "sweetalert2";
import xclose from "../../assets/x-close.svg"
import withReactContent from "sweetalert2-react-content";
import Alert from "../common/Alert";
import constants from "../../helpers/constants";
import InputBox from "../common/InputBox";
import FormButtons from "../common/FormButtons";
import { useNavigate } from "react-router-dom";
import { addVendorCode, getVendorCodes, updateVendorCode } from "../../services/vendor-service";
import Loader from "../common/loader";
import { validateAlphabets, validateAlphaNumeric } from "../../helpers/validations";
const VendorForm = (props) => {
    const MySwal = withReactContent(Swal);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [errorMessage, setErrorMessage] = useState();
    const [submit, setSubmit] = useState(false);
    const [fieldCount, setFieldCount] = useState([]);
    const [isFormChanged, setIsFormChanged] = useState(false);
    const [mandatoryFields, setMandatoryFields] = useState([]);
    const [mandatoryFieldsBKP, setMandatoryFieldsBKP] = useState([]);
    const navigate = useNavigate();

    let action = props.action;

    const handleSwitchChange = (e) => {
        setVendorObj((prevState) => ({
            ...prevState,
            validIndicator: e.target.checked ? "Y" : "N",
        }));
        setIsFormChanged(true);
    }
    useEffect(() => {
        setError();
        setErrorMessage()
    }, [props.action])

    useEffect(() => {
        if (mandatoryFields.length > 0) {
            setMandatoryFieldsBKP([
                ...mandatoryFields]);
        }
    }, [mandatoryFields])

    const validateDetails = () => {
        let tempError = false;
        for (let errorObj in error) {
            if (error[errorObj]) {
                tempError = true;
                break;
            }
        }

        if (tempError) {
            setErrorMessage("Please check above errors")
        } else {
            setErrorMessage("")
        }
        return tempError;
    }
    const submitForm = (e) => {
        if (isFormChanged) {
            e.preventDefault();
            setSubmit(submit ? false : true);
        }
        else {
            setErrorMessage("No changes in Vendor")
        }
    }

    useEffect(() => {

        let fieldValidation = 1;
        if (action === "ADD") {
            fieldValidation = 3;
        }
        if (fieldCount.length >= fieldValidation) {
            setSubmit(submit ? false : true);
            handleSubmit();
            setFieldCount([]);
        }
    }, [fieldCount, action]);

    const handleSubmit = async () => {

        if (!validateDetails()) {

            let confirmationMessage = action === "Add" ? "Are you sure do you want to Add New Vendor Code?" : action === "Edit" ? "Are you sure do you want to Update Selected Vendor Code?" : "";
            let title = action === "Add" ? "Add New Vendor Code" : action === "Edit" ? "Edit Vendor Code" : "";

            MySwal.fire({
                title: title,
                html: confirmationMessage,
                ...constants.CONFIRMATION_BOX_CONFIG
            }).then(async (selection) => {
                if (selection.isConfirmed) {
                    setLoading(true)
                    let result;

                    if (action === "Add") {
                        if (props.vendordata.filter((item) => item.vendorCode?.toLowerCase() === vendorObj.vendorCode?.toLowerCase()).length > 0) {
                            setErrorMessage("Vendor Code already exists.");
                            setLoading(false);
                            return;
                        }
                        
                        result = addVendorCode(vendorObj);
                    }
                    if (action === "Edit") {
                        result = updateVendorCode(vendorObj);
                    }
                    result.then((resp) => {
                        Alert("success", resp.message)
                        props.onHide();
                        props.setReload();
                    }).catch((err) => {
                        setErrorMessage(err);
                        setLoading(false)
                    })
                }
            });
        }
    }

    const validateChannel = (value) => {
        let isError = "";
        let pattern = /^[0-9]*$/;
        let regex = new RegExp(pattern);
        if (!regex.test(value)) {
            isError = "Please enter a Valid Number";
        }
        return isError;
    };


    const [vendorObj, setVendorObj] = useState(
        action === "Edit"
            ? props.rowdata
            :
            {
                vendorCode: "",
                vendorName: "",
                validIndicator: "Y",
                validationChannel: "",        
            }
    );

    const handleReset = () => {
        if (action === "Add") {
            setVendorObj({
                vendorCode: "",
                vendorName: "",
                validIndicator: "",
                validationChannel: ""
            });
            setMandatoryFields([...mandatoryFieldsBKP]);
        } else if (action === "Edit") {
            setVendorObj(props.rowdata)
        }
        setIsFormChanged(false);
        setError({});
        setErrorMessage()
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setVendorObj((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        setIsFormChanged(true);

    }
    const commonProps = { setError: setError, error: error, submit: submit, setFieldCount: setFieldCount, fieldCount: fieldCount, onChange: handleChange, required: "true", mandatoryFields: mandatoryFields, setMandatoryFields: setMandatoryFields }
    return (
        <>
        {loading && <Loader/>}
            {/* {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner">
            </Spinner></div>} */}
            <Modal
                {...props}
                size="lg"
                backdrop="static"
                className="vendorModal"
                enforceFocus={false}
            >
                <Modal.Header >
                    <Image src={xclose} onClick={props.onHide}></Image>
                    <Modal.Title className="modal-title">
                        {action} {action === "Edit" ? "" : "New"} Vendor Code
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Row >
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Vendor Code" maxLength={50} name="vendorCode" value={vendorObj.vendorCode} customValidation= {validateAlphaNumeric} {...commonProps} disabled={action === "Edit" ? true : false} required />
                        </Col>

                        <Col>
                            <Form.Label className="fieldLabel lblstatus" maxLength={50}>Status</Form.Label>
                            <Col lg={6} md={12} className="sw-status">
                                <Switch
                                isOn={vendorObj.validIndicator == "Y" ? true : false}
                                    handleToggle={(e) => {
                                        handleSwitchChange(e);
                                    }} 
                                    {...commonProps}
                                ></Switch>
                                <Form.Label className="fieldLabel">{vendorObj.validIndicator==="Y"?"Active":"Inactive"} </Form.Label>
                            </Col>
                        </Col>

                    </Row>
                    <Row >
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Vendor Name" maxLength={50} name="vendorName" value={vendorObj.vendorName} customValidation= {validateAlphabets} {...commonProps} required />
                        </Col>
                        <Col lg={6} md={12} className="txt-input">
                            <InputBox type="text" label="Validation Channel" maxLength={50} name="validationChannel" value={vendorObj.validationChannel} {...commonProps} required customValidation={validateChannel}/>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {errorMessage && (
                                <Form.Text className="text-danger">
                                    {errorMessage}
                                </Form.Text>
                            )}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <FormButtons handleReset={handleReset} submitForm={submitForm} action={action} mandatoryFields={mandatoryFields}></FormButtons>
                </Modal.Footer>
            </Modal >

        </>
    );
}


export default VendorForm;
